import { ReportStatus } from "../../shared/interfaces/ReportStatus";
import { EDITABLE_STATUSES } from "../EditSection/hooks/useReportData";

export type FinalEditsGate = "loading" | "not-owner" | "wrong-status" | "ok";

/**
 * Access decision for the officer-only signing surface, from the metadata
 * query. Fail-closed: a metadata error is treated as not-owner (the officer
 * must never see the sign CTA on unverified ownership), and statuses outside
 * the editable whitelist bounce to the read-only preview so a deep link can
 * never re-sign a SIGNED/IN CO REVIEW/RMS COMMITTED report.
 */
export function finalEditsGate(args: {
  metadata: { reportStatus: string; userId?: string | null } | undefined;
  isError: boolean;
  viewerUserId: string | null | undefined;
}): FinalEditsGate {
  const { metadata, isError, viewerUserId } = args;
  if (isError) return "not-owner";
  if (!metadata) return "loading";
  // Ownership requires a POSITIVE match on a legal surface: an unresolved
  // viewer keeps the page loading; a record with no owner id fails closed.
  // (The Phase-2 inline check silently passed when either id was missing.)
  if (!viewerUserId) return "loading";
  if (!metadata.userId) return "not-owner";
  if (viewerUserId !== metadata.userId) {
    return "not-owner";
  }
  if (!EDITABLE_STATUSES.includes(metadata.reportStatus as ReportStatus)) {
    return "wrong-status";
  }
  return "ok";
}
